import Splide from 'splide';
export const init = () =>{
	setCal();
    setAnimes();
}

const setAnimes=()=>{
    import(/* webpackChunkName:"entertainment/factory/lotte-assets/js/_DecoAnime" */'./_DecoAnime.js').then(DecoAnime => {
        const deco = new DecoAnime.default();
        deco.init({
            target:"#decoGCG",
        });

        const play=document.querySelector("#ctg-gcg .animeControl button.play");
        const stop=document.querySelector("#ctg-gcg .animeControl button.stop");
        play.addEventListener("click",(e)=>{
            deco.Play();
            play.classList.remove('active');
            stop.classList.add('active');
        });
        stop.addEventListener("click",(e)=>{
            deco.Pause();
            stop.classList.remove('active');
            play.classList.add('active');
        });
    });
    import(/* webpackChunkName:"entertainment/factory/lotte-assets/js/_DecoAnime" */'./_DecoAnime.js').then(DecoAnime => {
        const deco = new DecoAnime.default();
        deco.init({
            target:"#decoCB",
        });
        
        const play=document.querySelector("#ctg-cb .animeControl button.play");
        const stop=document.querySelector("#ctg-cb .animeControl button.stop");
        play.addEventListener("click",(e)=>{
            deco.Play();
            play.classList.remove('active');
            stop.classList.add('active');
        });
        stop.addEventListener("click",(e)=>{
            deco.Pause();
            stop.classList.remove('active');
            play.classList.add('active');
        });
    });
    import(/* webpackChunkName:"entertainment/factory/lotte-assets/js/_DecoAnime" */'./_DecoAnime.js').then(DecoAnime => {
        const deco = new DecoAnime.default();
        deco.init({
            target:"#decoI",
        });

        const play=document.querySelector("#ctg-i .animeControl button.play");
        const stop=document.querySelector("#ctg-i .animeControl button.stop");
        play.addEventListener("click",(e)=>{
            deco.Play();
            play.classList.remove('active');
            stop.classList.add('active');
        });
        stop.addEventListener("click",(e)=>{
            deco.Pause();
            stop.classList.remove('active');
            play.classList.add('active');
        });
    });
}

let calArr=[];
const options = {
    type:'loop',
    mediaQuery: 'max',
    fixedWidth:"1200px",
    perPage: 3,
    focus: "center",
    perMove:1,
    arrows:false,
    pagination:false,
    waitForTransition:false,
    //gap:"3px",
    autoplay: true,
    interval: 4000,
    speed: 500,
    //padding: "15%",
    pauseOnFocus: false,
    updateOnMove: true,
    breakpoints: {
        1199: {
            focus: "center",
            fixedWidth:"90%",
            perPage: 3,
        }
    }
}

const setCal =()=>{
    const sels=document.querySelectorAll('.splide');
    let cnt=0;
    sels.forEach((cal)=>{
        const setMountFunc = ( Splide, Components, options ) => {
            const mount=()=> {
                Splide.on( 'mounted', function () {
                    const selPtLi=cal.querySelectorAll(".contWrap ul li button");
                    selPtLi.forEach((c)=>{
                        c.addEventListener("click",(e)=>{
                            const tgNo=e.target.closest("li").dataset.no;
                            Splide.go(Number(tgNo));
                        })
                    });
                    
                    const prvBt=cal.querySelector('.contWrap .arrow.prev');
                    const nxtBt=cal.querySelector('.contWrap .arrow.next');
                    prvBt.addEventListener('click',(e)=>{
                        Splide.go('<');
                    });
                    nxtBt.addEventListener('click',(e)=>{
                        Splide.go('>');
                    });

                    const spBts=cal.querySelector('.spBts');
                    const spBt=spBts.querySelectorAll('button');
                    spBt.forEach((b)=>{
                        b.addEventListener('click',(e)=>{
                            if(spBts.classList.contains('stop')){
                                Splide.Components.Autoplay.play();
                                Splide.go('>');
                                spBts.classList.remove('stop');
                            }else{
                                Splide.Components.Autoplay.pause();
                                spBts.classList.add('stop');
                            }
                        });
                    });
                });
                Splide.on( 'move', function (e) {
                    const actBts=cal.querySelectorAll(".contWrap ul li button.active");
                    const selPtLi=cal.querySelectorAll(".contWrap ul li button");
                    cal.querySelector(".contWrap .pageNum span.now").textContent=e+1;
                    actBts.forEach((b)=>{
                        b.classList.remove('active');
                    });
                    selPtLi[e].classList.add('active');
                });
            }
            return {
                mount,
            };
        }

        const initCar =()=>{
            const vcnt=cal.querySelectorAll("li.splide__slide").length;
            const bts=cal.querySelector(".contWrap ul");
            const pgNum=cal.querySelector(".contWrap .pageNum");

            pgNum.querySelector("span.total").textContent=vcnt;
            pgNum.querySelector("span.now").textContent=1;

            let btHtml='';
            for(let i=0;i<vcnt;i++){
                let cls="";
                if(i==0){
                    cls='active';
                }
                bts.insertAdjacentHTML('beforeend','<li data-no="'+i+'"><button class="'+cls+'" type="button">'+(i+1)+'</button></li>');
            }
        }

        initCar();
        setCal[cnt]=new Splide(cal,options).mount({setMountFunc});
        cnt++;
    });

    
}	